import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { api, errorMessage } from "../../lib/api";
import { updateCachedBranding } from "../../lib/config";
import { useLang } from "../../lib/i18n";

const FIELDS = [
  { key: "company_name_en", label: "Company name (English)", dir: "ltr", required: true, placeholder: "Inception",
    hint: "Saved into contacts (Save Contact) and shown on the Apple Wallet pass." },
  { key: "company_name_ar", label: "Company name (Arabic)", dir: "rtl", placeholder: "اسم الشركة بالعربي",
    hint: "Shown in the browser tab title when a card is viewed in Arabic." },
  { key: "company_website", label: "Company website", dir: "ltr", placeholder: "inception.sa",
    hint: "Shown as a \"Visit company website\" button on deactivated card pages." },
];

export const OrganizationPanel = () => {
  const { t } = useLang();
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/settings/organization").then(({ data }) => setForm(data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    const body = Object.fromEntries(FIELDS.map((f) => [f.key, form[f.key] || ""]));
    try {
      const { data } = await api.put("/admin/settings/organization", body);
      setForm(data);
      updateCachedBranding(data);
      toast.success(t("Organization settings saved"));
    } catch (err) { toast.error(errorMessage(err)); } finally { setSaving(false); }
  };

  if (!form) return <div className="h-64 animate-pulse rounded-3xl bg-slate-200" />;
  return (
    <form onSubmit={save} className="max-w-2xl space-y-5 rounded-3xl border border-slate-200/80 bg-white p-6" data-testid="organization-panel">
      {FIELDS.map((f) => (
        <div key={f.key} className="space-y-1.5">
          <Label htmlFor={`org-${f.key}`} className="text-xs font-bold uppercase tracking-wider text-slate-500">
            {t(f.label)}{f.required && <span className="text-wade"> *</span>}
          </Label>
          <Input id={`org-${f.key}`} dir={f.dir} required={f.required} value={form[f.key] || ""} placeholder={f.placeholder}
            onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`org-${f.key}`}
            className={`h-12 rounded-xl ${f.dir === "rtl" ? "font-arabic text-right" : "text-left"}`} />
          <p className="text-xs text-slate-400">{t(f.hint)}</p>
        </div>
      ))}
      <button type="submit" disabled={saving} data-testid="org-save-button"
        className="btn-press min-h-[50px] rounded-2xl bg-slate-900 px-6 font-semibold text-white disabled:opacity-60">
        {saving ? t("Saving…") : t("Save organization")}
      </button>
    </form>
  );
};
